import { Button, Icon, IconSource, Stack, Typography } from '@prenuvo/halo';
import { WarningTriangle } from '@prenuvo/halo-icon';

import { redirectToLogin } from '../util/redirect.util';

interface PageGuardProps {
  icon?: IconSource;
  message: string;
  showLoginButton?: boolean;
  title: string;
}

export function PageGuard({
  icon = WarningTriangle,
  message,
  showLoginButton = true,
  title,
}: PageGuardProps) {
  return (
    <Stack alignment="center" className="mx-auto h-screen" justification="center">
      <Stack
        className="m-8 rounded-xl border border-orange-700 p-16 text-center"
        gap={8}
        variant="vertical"
      >
        <Stack alignment="center" variant="vertical">
          <Icon className={{ root: 'fill-orange-700' }} size="lg" source={icon} />
          <Typography translationKey={title} variant="h2" />
        </Stack>

        <Stack alignment="center" gap={4} variant="vertical">
          <Typography className="italic dark:text-neutral-500" translationKey={message} />

          {showLoginButton && (
            <Button onClick={redirectToLogin} size="lg" translationKey="FCT.RETURN_TO_LOGIN" />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
